import * as XLSX from 'xlsx';
import {BookType} from 'xlsx';
import {Injectable} from '@angular/core';
import {XlSheetModel} from '../_models/xl.model';

@Injectable({
  providedIn: 'root'
})
export class XlExportService {

  // ----------------------------------------
  // STATIC HELPER FUNCTIONS
  // ----------------------------------------

  // FLATTEN OBJECT

  private static mergeObj(objects: any) {
    const out = {};
    for (let i = 0; i < objects.length; i++) {
      for (const p in objects[i]) {
        if (objects[i].hasOwnProperty(p)) {
          out[p] = objects[i][p];
        }
      }
    }
    return out;
  }

  private static iterateObj(obj, name, stem): any {
    let out = {};
    const newStem = (typeof stem !== 'undefined' && stem !== '') ? stem + '_' + name : name;
    if (typeof obj !== 'object') {
      out[newStem] = obj;
      return out;
    }
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        const prop = XlExportService.iterateObj(obj[p], p, newStem);
        out = XlExportService.mergeObj([out, prop]);
      }
    }
    return out;
  }

  // CREATE NEW WORKBOOK
  private static newWorkBook(): any {
    // ALL YOU NEED FOR A VALID WORKBOOK IS ARRAYS SHEETNAMES AND SHEETS
    const wb: any = {};
    wb.SheetNames = [];
    wb.Sheets = [];
    return wb;
  }

  // CHECK IF JSON
  private static checkJSON(itemToCheck: string): boolean {
    let item = {};
    try {
      item = JSON.parse(itemToCheck);
    } catch (e) {
      return false;
    }
    return typeof item === 'object' && item !== null;
  }

  // ----------------------------------------
  // GENERATE XLSX FOR GENERIC DATA
  // ----------------------------------------

  static exportGeneric(
    sheetsToExport: XlSheetModel[],
    fileName: string,
    extension: BookType = 'xlsx',
    colsToInclude: string[] = [],
    colsToExclude: string[] = [],
    isToFlatten: boolean = false,
    isToStringify: boolean = false,
  ) {

    const wb = XlExportService.newWorkBook();

    for (const curSheet of sheetsToExport) {

      // IF NOT AN ARRAY THEN WRAP IN ARRAY
      let arrData = Array.isArray(curSheet.sheetData) ? JSON.parse(JSON.stringify(curSheet.sheetData)) : JSON.parse(JSON.stringify([curSheet.sheetData]));

      // FLATTEN ARRAY OBJECTS IN CASE OF HIERARCHIES
      if (isToFlatten) {
        for (let i = 0; i < arrData.length; i++) {
          arrData[i] = XlExportService.iterateObj(arrData[i], '', '');
        }
      }

      // ONLY KEEP COLUMNS SPECIFIED BY COLSTOINCLUDE, IF ANY
      if (colsToInclude.length > 0) {
        arrData = arrData.map((a) => {
          const obj = {};
          for (const prop of colsToInclude) {
            obj[prop] = a[prop];
          }
          return obj;
        });
      }

      // REMOVE COLUMNS IF ANY SPECIFIED IN COLSTOEXCLUDE
      if (colsToExclude.length > 0) {
        for (const curData of arrData) {
          for (const curCol of colsToExclude) {
            if (curData.hasOwnProperty(curCol)) {
              delete curData[curCol];
            }
          }
        }
      }

      // SOME COLUMNS CONTAIN OBJECTS: STRINGIFY
      if (isToStringify) {
        for (const curData of arrData) {
          for (const curCol in curData) {
            if (curData.hasOwnProperty(curCol) && XlExportService.checkJSON(JSON.stringify(curData[curCol]))) {
              curData[curCol] = JSON.stringify(curData[curCol]);
            }
          }
        }
      }

      // BUILD SHEET
      wb.SheetNames.push(curSheet.sheetName);
      wb.Sheets[curSheet.sheetName] = XLSX.utils.json_to_sheet(arrData);

    }

    // CLEAN FILENAME
    const fName = fileName.replace(/ /g, '_');
    // CREATE FILE
    XLSX.writeFile(wb, fName + '.' + extension, {bookType: extension});
  }

}
